<template lang="pug">

.verte
  section.verte-intro
    AppTitle(:title="$t('mantra')")

    AppLink(to="https://github.com/baianat/verte" class="button-link" :title="$t('github')")  {{$t('github')}}


  section.verte-features.u-mt-lg
    .grid.is-ultrawide-8.is-widescreen-9.is-desktop-10.is-center
      .column
        h2.u-mb-mi {{$t('features')}}
        .grid.is-mb.is-tablet-6
          .column(v-for="item in $t('featuresItems')")
            h4 {{item.title}}
            p {{item.desc}}


  section.verte-install.u-mt-lg
    .grid.is-ultrawide-8.is-widescreen-9.is-desktop-10.is-center
      .column
        AppTitle.u-mb-sm(:title="$t('installation')" tag="h2")
        prism(language="js" :code="install")

  section.verte-features.u-mt-lg
    .grid.is-ultrawide-8.is-widescreen-9.is-desktop-10.is-center
      .column
        .grid.is-mb.is-middle
          .column.is-desktop-4.is-tablet-6
            img( src='https://cdn.baianat.com/static/resources/verte/2.png', srcset='https://cdn.baianat.com/static/resources/verte/2.png 1x, https://cdn.baianat.com/static/resources/verte/2@2x.png 2x')
          .column.is-desktop-7.is-tablet-6
            h4 {{$t('standalone')}}
            p {{$t('standaloneDesc')}}


  section.verte-cta.u-mt-lg
    AppTitle(:title="$t('cta')" tag="h2")
    AppLink(to="https://baianat.github.io/verte/guide/getting-started.html" class="button-link is-white" :title="$t('getStarted')") {{$t('getStarted')}}



  .u-mb-md

</template>
<style lang="stylus">
$clMain = #004a69
$clGreen = #00a14f

.app.is-verte
  overflow: hidden

  &.is-dark
    .header.is-scroll
      background: $clMain

.verte
  &-intro
    padding-top: unitRes(200, 400)
    padding-bottom: unitRes(120, 240)
    margin-left: -12vw
    margin-right: -12vw
    padding-right: 8vw
    padding-left: 8vw
    z-index: 0
    position: relative
    background-color: $clMain
    background-repeat: no-repeat
    color: $clWhite
    background-image: url('https://cdn.baianat.com/static/resources/verte/1.png')
    background-position: 90% top
    background-attachment: fixed
    background-size: contain

    +mq($until: 'tablet')
      background-size: cover

    &-img
      position: absolute
      top: -90%
      right: -45%
      z-index: -1

  &-cta
    background-color: $clGreen
    padding: unitRes(20, 160)
    color: $clWhite
    background-image: url('https://cdn.baianat.com/static/resources/verte/3.png')
    background-repeat: no-repeat
    background-position: 80% center
    background-attachment: fixed

html[lang^='ar']
  .verte
    &-cta
      background-position: 20% center

    &-intro
      background-position: 10% top
</style>

<script>
import Prism from '~/components/Prism';
import { generateSeoMeta } from '~/utils/seo';

export default {
  scrollToTop: true,
  meta: {
    theme: 'is-verte is-fixedHeader is-whiteHeader',
    logoText: 'logoVerteTypo',
    logoIcon: 'logoVerteIcon'
  },
  head: generateSeoMeta(
    {
      title: 'pageTitle',
      description: 'pageDesc'
    },
    { i18n: true }
  ),
  components: {
    Prism
  },
  data: () => ({
    install: `npm install verte
# or use yarn
yarn add verte

# Usage

<template>
  <verte picker="square" model="rgb"></verte>
</template>

<script>
  import Verte from 'verte';
  import 'verte/dist/verte.css';
  // register component globally
  Vue.component(Verte.name, Verte);

  new Vue ({
    el: '#app',
    // OR register locally
    components: { Verte }
  });
<\/script>
`
  })
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Verte",
    "pageDesc":"Enjoy a customizable color picker component built for Vue.js with a minimal size. It also comes in plain vanilla JavaScript.",
    "mantra":"Lightweight color |picker plugin",
    "github":"Github",
    "features":"Features",
    "featuresItems":{
      "1":{
        "title":"Adaptable Layout",
        "desc":"Comes in both vertical and vertical-widget layouts for diferent situations."
      },
      "2":{
        "title":"Tiny Size",
        "desc":"Verte is small and won’t introduce performance costs. It’s only 7kb gzipped."
      },
      "3":{
        "title":"Customizable icon",
        "desc":"Make use of Vue slots to set your own custom Verte icon with ease."
      },
      "4":{
        "title":"Many Models",
        "desc":"Choose from multiple color models including RGB, HSL, and Hex."
      }
    },
    "installation":"Installation |and Usage",
    "standalone":"Standalone and Vue.js",
    "standaloneDesc":"Enjoy a fully customizable color picker component built for Vue.js with a minimal size. It also comes in plain vanilla JavaScript.",
    "cta":"Get colorful |with Verte",
    "getStarted":"Get started"
  },
  "ar": {
    "pageTitle":"Verte",
    "pageDesc":"استمتع بمنتقي الألوان القابل للتخصيص بالكامل والمبني خصيصًا لـ Vue.js بأقل حجم والذي يأتي مع vanilla JavaScript",
    "mantra":"مُنتقي الألوان",
    "github":"غيت هاب",
    "features":"المميزات",
    "featuresItems":{
      "1":{
        "title":"تخطيط قابل للتكيف",
        "desc":"يأتي معه كل من layout الأجزاء العمودية والرأسية للحالات المختلفة."
      },
      "2":{
        "title":"حجم صغير",
        "desc":"Verte صغير ولا يؤثر على الأداء، حيث لا يتجاوز حجمه 7 كيلوبايت فقط."
      },
      "3":{
        "title":"أيقونات مخصصة",
        "desc":"استفيد من إدراج Vue لضبط أيقونة Verte المخصصة الخاصة بك بكل سهولة."
      },
      "4":{
        "title":"أنظمة متعددة",
        "desc":"اختر من أنظمة متعددة للألوان بما في ذلك RGB و HSL و Hex."
      }
    },
    "installation":"التثبيت |والاستخدام",
    "standalone":"مستقل و Vue.js",
    "standaloneDesc":"استمتع بمكون منتقي الألوان القابل للتخصيص بالكامل والمبني خصيصًا لـ Vue.js بأقل حجم. كما أنه يأتي مع vanilla JavaScript سهل.",
    "cta":"العب بالألوان |مع Verte.",
    "getStarted":"ابدأ الآن!"
  }
}
</i18n>
